module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "wrap",
    attrs: {
      "id": "actions-top"
    }
  }, [_c('router-link', {
    staticClass: "btn prev btn-full",
    attrs: {
      "to": _vm.back
    }
  }, [_c('i', {
    staticClass: "icon-go"
  }), _vm._v("\n    Retour\n  ")]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32f7ff78","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ActionBar.vue
// module id = 750
// module chunks = 0